/**
 * API Service
 * Location: frontend/src/services/api.js
 */

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001/api';

/**
 * Make authenticated API request
 */
export const apiRequest = async (endpoint, options = {}) => {
  const token = localStorage.getItem('token');

  const headers = {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` }),
    ...options.headers
  };

  const response = await fetch(`${API_URL}${endpoint}`, {
    ...options,
    headers
  });

  return response;
};

/**
 * GET request
 */
export const get = async (endpoint) => {
  return apiRequest(endpoint, { method: 'GET' });
};

/**
 * POST request
 */
export const post = async (endpoint, data) => {
  return apiRequest(endpoint, {
    method: 'POST',
    body: JSON.stringify(data)
  });
};

/**
 * PUT request
 */
export const put = async (endpoint, data) => {
  return apiRequest(endpoint, {
    method: 'PUT',
    body: JSON.stringify(data)
  });
};

/**
 * DELETE request
 */
export const del = async (endpoint) => {
  return apiRequest(endpoint, { method: 'DELETE' });
};

/**
 * Auth API functions
 * FIXED: login now accepts either (email, password) OR (credentials object)
 */
export const authAPI = {
  // Support both: login(email, password) OR login({email, password})
  login: (emailOrCredentials, password) => {
    if (typeof emailOrCredentials === 'object') {
      // Called with object: login({email, password})
      return post('/auth/login', emailOrCredentials);
    }
    // Called with separate args: login(email, password)
    return post('/auth/login', { email: emailOrCredentials, password });
  },

  register: (emailOrData, password, nickname) => {
    if (typeof emailOrData === 'object') {
      return post('/auth/register', emailOrData);
    }
    return post('/auth/register', { email: emailOrData, password, nickname });
  },

  logout: () => post('/auth/logout', {}),
  me: () => get('/auth/me'),
  forgotPassword: (email) => post('/auth/forgot-password', { email }),
  resetPassword: (token, password) => post('/auth/reset-password', { token, password }),
};

export { API_URL };

export default {
  apiRequest,
  get,
  post,
  put,
  del,
  authAPI,
  API_URL
};